import React from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

const mapStateToProps = state => ({
  country: state.country,
});

@connect(mapStateToProps)
export default class BasicMeta extends React.PureComponent {
  render() {
    const { description, title } = this.props.descriptions[this.props.country];

    const props = {
      meta: [{
        name: 'description',
        content: description,
      }, {
        name: 'og:description',
        content: description,
      }],
      title,
    };

    return (
      <Helmet {...props} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/BasicMeta.jsx